type Language = 'ko' | 'en' | 'ja';

type NameByLanguage = Record<Language, string>;

export const BANK_LIST: { name: NameByLanguage; code_list: string[] }[] = [
  {
    name: {
      ko: '산업은행',
      en: 'KDB Bank',
      ja: 'KDB Bank',
    },
    code_list: ['002', 'KDB'],
  },
  {
    name: {
      ko: '기업은행',
      en: 'IBK',
      ja: 'IBK',
    },
    code_list: ['003', 'IBK'],
  },
  {
    name: {
      ko: '국민은행',
      en: 'KB Kookmin Bank',
      ja: 'KB Kookmin Bank',
    },
    code_list: ['004', 'KB'],
  },
  {
    name: {
      ko: '외환은행',
      en: 'KEB(Hana Bank)',
      ja: 'KEB(Hana Bank)',
    },
    code_list: ['005', 'KEB'],
  },
  {
    name: {
      ko: '수협',
      en: 'Suhyup Bank',
      ja: 'Suhyup Bank',
    },
    code_list: ['007', 'SUHYUP'],
  },
  {
    name: {
      ko: '농협',
      en: 'NH Bank',
      ja: 'NH Bank',
    },
    code_list: ['011', 'NH'],
  },
  {
    name: {
      ko: '우리은행',
      en: 'WOORI BANK',
      ja: 'WOORI BANK',
    },
    code_list: ['020', 'WOORI'],
  },
  {
    name: {
      ko: 'SC제일은행',
      en: 'SC Bank Korea',
      ja: 'SC Bank Korea',
    },
    code_list: ['023', 'SC'],
  },
  {
    name: {
      ko: '한국씨티은행',
      en: 'Citibank Korea',
      ja: 'Citibank Korea',
    },
    code_list: ['027', 'CITY'],
  },
  {
    name: {
      ko: '광주은행',
      en: 'Kwangju Bank',
      ja: 'Kwangju Bank',
    },
    code_list: ['034', 'GWANGJU'],
  },
  {
    name: {
      ko: '경남은행',
      en: 'BNK Kyongnam Bank',
      ja: 'BNK Kyongnam Bank',
    },
    code_list: ['039', 'GYEONGNAM'],
  },
  {
    name: {
      ko: 'iM뱅크(대구)',
      en: 'iMBank(DGB)',
      ja: 'iMBank(DGB)',
    },
    code_list: ['031', 'DAEGU'],
  },
  {
    name: {
      ko: '부산은행',
      en: 'BNK BUSAN BANK',
      ja: 'BNK BUSAN BANK',
    },
    code_list: ['032', 'BUSAN'],
  },
  {
    name: {
      ko: '전북은행',
      en: 'JEONBUK BANK',
      ja: 'JEONBUK BANK',
    },
    code_list: ['037', 'JEONBUK'],
  },
  {
    name: {
      ko: '제주은행',
      en: 'JEJUBANK',
      ja: 'JEJUBANK',
    },
    code_list: ['035', 'JEJU'],
  },
  {
    name: {
      ko: '새마을금고',
      en: 'MG Community Credit Cooperatives',
      ja: 'MG Community Credit Cooperatives',
    },
    code_list: ['045'],
  },
  {
    name: {
      ko: '신협',
      en: 'NACUFOK',
      ja: 'NACUFOK',
    },
    code_list: ['048', 'SHINHYUP'],
  },
  {
    name: {
      ko: '상호저축은행',
      en: 'Mutual Savings Bank',
      ja: 'Mutual Savings Bank',
    },
    code_list: ['050'],
  },
  {
    name: {
      ko: 'HSBC은행',
      en: 'HSBC Korea',
      ja: 'HSBC Korea',
    },
    code_list: ['054', 'HSBC'],
  },
  {
    name: {
      ko: '우체국',
      en: 'KoreaPostbank',
      ja: 'KoreaPostbank',
    },
    code_list: ['071', 'POST'],
  },
  {
    name: {
      ko: '하나은행',
      en: 'Hana Bank',
      ja: 'Hana Bank',
    },
    code_list: ['081', 'HANA'],
  },
  {
    name: {
      ko: '신한은행',
      en: 'SHINHAN BANK',
      ja: 'SHINHAN BANK',
    },
    code_list: ['088', 'SHINHAN'],
  },
  {
    name: {
      ko: '케이뱅크',
      en: 'Kbank',
      ja: 'Kbank',
    },
    code_list: ['089', 'KBANK'],
  },
  {
    name: {
      ko: '카카오뱅크',
      en: 'kakaobank',
      ja: 'kakaobank',
    },
    code_list: ['090', 'KAKAOBANK'],
  },
  {
    name: {
      ko: '토스뱅크',
      en: 'tossbank',
      ja: 'tossbank',
    },
    code_list: ['092'],
  },
  {
    name: {
      ko: '산림조합중앙회',
      en: 'National Forestry Cooperative Federation',
      ja: 'National Forestry Cooperative Federation',
    },
    code_list: ['064', 'SANLIM'],
  },
  {
    name: {
      ko: '유안타증권',
      en: 'Yuanta Securities',
      ja: 'Yuanta Securities',
    },
    code_list: ['209', 'YUANTA_SECURITIES'],
  },
  {
    name: {
      ko: '삼성증권',
      en: 'Samsung Securities',
      ja: 'Samsung Securities',
    },
    code_list: ['240', 'SAMSUNG_SECURITIES'],
  },
  {
    name: {
      ko: '한국투자증권',
      en: 'Korea Investment & Securities',
      ja: 'Korea Investment & Securities',
    },
    code_list: ['243', 'KOREA_INVESTMENT_SECURITIES'],
  },
  {
    name: {
      ko: 'NH투자증권',
      en: 'NH Investment & Securities',
      ja: 'NH Investment & Securities',
    },
    code_list: ['247', 'NH_INVESTMENT_SECURITIES'],
  },
  {
    name: {
      ko: 'SK증권',
      en: 'SK Securities',
      ja: 'SK Securities',
    },
    code_list: ['266', 'SK_SECURITIES'],
  },
  {
    name: {
      ko: '대신증권',
      en: 'Daishin Securities',
      ja: 'Daishin Securities',
    },
    code_list: ['267', 'DAESHIN_SECURITIES'],
  },
  {
    name: {
      ko: '신한금융투자',
      en: 'Shinhan Investment Corp',
      ja: 'Shinhan Investment Corp',
    },
    code_list: ['278', 'SHINHAN_INVESTMENT_SECURITIES'],
  },
  {
    name: {
      ko: '유진투자증권',
      en: 'Eugene Investment & Securities',
      ja: 'Eugene Investment & Securities',
    },
    code_list: ['280', 'EUGENE_INVESTMENT_SECURITIES'],
  },
  {
    name: {
      ko: '메리츠증권',
      en: 'Meritz Securities',
      ja: 'Meritz Securities',
    },
    code_list: ['287', 'MERITZ_SECURITIES'],
  },
];

export const CARD_LIST: { name: NameByLanguage; code: string }[] = [
  {
    name: {
      ko: 'KB국민',
      en: 'Kookmin',
      ja: 'Kookmin',
    },
    code: 'KB',
  },
  {
    name: {
      ko: '비씨',
      en: 'BC',
      ja: 'BC',
    },
    code: 'BC',
  },
  {
    name: {
      ko: '씨티',
      en: 'Citi',
      ja: 'Citi',
    },
    code: 'CITY',
  },
  {
    name: {
      ko: '광주',
      en: 'Kwangju',
      ja: 'Kwangju',
    },
    code: 'GWANGJU',
  },
  {
    name: {
      ko: '하나',
      en: 'Hana',
      ja: 'Hana',
    },
    code: 'HANA',
  },
  {
    name: {
      ko: '현대',
      en: 'Hyundai',
      ja: 'Hyundai',
    },
    code: 'HYUNDAI',
  },
  {
    name: {
      ko: '제주',
      en: 'Jeju',
      ja: 'Jeju',
    },
    code: 'JEJU',
  },
  {
    name: {
      ko: '전북',
      en: 'Jeonbuk',
      ja: 'Jeonbuk',
    },
    code: 'JEONBUK',
  },
  {
    name: {
      ko: '카카오뱅크',
      en: 'kakaobank',
      ja: 'kakaobank',
    },
    code: 'KAKAOBANK',
  },
  {
    name: {
      ko: 'KDB산업은행',
      en: 'KDB',
      ja: 'KDB',
    },
    code: 'KDB',
  },
  {
    name: {
      ko: '롯데',
      en: 'LOCA',
      ja: 'LOCA',
    },
    code: 'LOTTE',
  },
  {
    name: {
      ko: 'NH농협',
      en: 'Nonghyup',
      ja: 'Nonghyup',
    },
    code: 'NH',
  },
  {
    name: {
      ko: '우체국',
      en: 'KoreaPost',
      ja: 'KoreaPost',
    },
    code: 'POST',
  },
  {
    name: {
      ko: '삼성',
      en: 'Samsung',
      ja: 'Samsung',
    },
    code: 'SAMSUNG',
  },
  {
    name: {
      ko: '신한',
      en: 'Shinhan',
      ja: 'Shinhan',
    },
    code: 'SHINHAN',
  },
  {
    name: {
      ko: '신협',
      en: 'CU',
      ja: 'CU',
    },
    code: 'SHINHYUP',
  },
  {
    name: {
      ko: '수협',
      en: 'Suhyup',
      ja: 'Suhyup',
    },
    code: 'SUHYUP',
  },
  {
    name: {
      ko: '우리',
      en: 'Woori',
      ja: 'Woori',
    },
    code: 'WOORI',
  },
  {
    name: {
      ko: '케이뱅크',
      en: 'Kbank',
      ja: 'Kbank',
    },
    code: 'KBANK',
  },
  {
    name: {
      ko: '',
      en: '',
      ja: '',
    },
    code: 'UNKNOWN',
  },
];

export const CARD_POINT_LIST: { name: NameByLanguage; code: string }[] = [
  {
    name: {
      ko: '포인트리',
      en: '포인트리',
      ja: '포인트리',
    },
    code: 'KB',
  },

  {
    name: {
      ko: '삼성카드 포인트',
      en: '삼성카드 포인트',
      ja: '삼성카드 포인트',
    },
    code: 'SAMSUNG',
  },
  {
    name: {
      ko: '현대카드 M포인트',
      en: '현대카드 M포인트',
      ja: '현대카드 M포인트',
    },
    code: 'HYUNDAI',
  },

  {
    name: {
      ko: 'TOP포인트',
      en: 'TOP포인트',
      ja: 'TOP포인트',
    },
    code: 'BC',
  },

  {
    name: {
      ko: '마이신한포인트',
      en: '마이신한포인트',
      ja: '마이신한포인트',
    },
    code: 'SHINHAN',
  },

  {
    name: {
      ko: 'L.POINT',
      en: 'L.POINT',
      ja: 'L.POINT',
    },
    code: 'LOTTE',
  },
  {
    name: {
      ko: '하나머니',
      en: '하나머니',
      ja: '하나머니',
    },
    code: 'HANA',
  },
  {
    name: {
      ko: '채움포인트',
      en: '채움포인트',
      ja: '채움포인트',
    },
    code: 'NH농협',
  },
  {
    name: {
      ko: '우리WON꿀머니',
      en: '우리WON꿀머니',
      ja: '우리WON꿀머니',
    },
    code: 'WOORI',
  },
  {
    name: {
      ko: '',
      en: '',
      ja: '',
    },
    code: 'UNKNOWN',
  },
];

export const CARD_POINT_HELP_TEXT = [
  {
    code: 'SAMSUNG',
    contents: [
      '결제금액만큼 포인트 보유 시, 전액 사용 가능합니다.',
      '사용 가능한 포인트만큼 결제금액에서 차감 후, 다음 달 카드 대금으로 청구됩니다.',
      '포인트 관련 사항은 카드사 홈페이지에서 확인할 수 있습니다. ',
    ],
  },
  {
    code: 'WOORI',
    contents: [
      '보유한 우리WON꿀머니 기준 전액이 사용됩니다.',
      '우리WON꿀머니 사용 시점에 잔여 포인트 기준 전액 차감되며, 포인트 부족 시 잔여 금액은 신용/체크카드로 승인됩니다.',
      '포인트 관련 문의사항은 우리카드 고객센터(1588-9955)로 연락 바랍니다.',
    ],
  },
];

/**
 * 은행 코드로 은행 이름을 반환한다.
 * @param lang 언어
 * @param bank_code 은행 코드
 */
export const getBankNameByCode = (lang: Language, bank_code: string): string => {
  for (const bank of BANK_LIST) {
    if (bank.code_list.includes(bank_code)) {
      return bank.name[lang];
    }
  }
  return '-';
};

/**
 * 카드 코드로 카드 이름을 반환한다.
 * @param lang 언어
 * @param card_code 카드 코드
 */
export const getCardNameByCode = (lang: Language, card_code: string): string => {
  for (const card of CARD_LIST) {
    if (card.code === card_code) {
      return card.name[lang] + (lang === 'ko' ? '카드' : '');
    }
  }
  return '-';
};

/**
 * 파이낸셜 컴터니 코드로 카드 및 은행 이름을 반환한다.
 * @param lang 언어
 * @param financial_company_code 파이낸셜 컴터니 코드
 */
export const getNameByFinancialCompanyCode = (lang: Language, financial_company_code: string): string => {
  if (!financial_company_code) return '';

  const [type, code] = financial_company_code.split('_');

  if (type === 'B') {
    return getBankNameByCode(lang, code);
  }
  if (type === 'C') {
    return getCardNameByCode(lang, code);
  }
  return '';
};

/**
 * 파이낸셜 컴터니 코드로 카드 포인트 이름을 반환한다.
 * @param lang 언어
 * @param financial_company_code 파이낸셜 컴터니 코드
 */
export const getPointNameByFinancialCompanyCode = (lang: Language, financial_company_code: string): string => {
  const [, code] = financial_company_code.split('_');
  return getCardPointNameByCode(lang, code);
};

/**
 * 카드 코드로 카드 포인트 이름을 반환한다.
 * @param lang 언어
 * @param card_code 카드 코드
 */
export const getCardPointNameByCode = (lang: Language, card_code: string): string => {
  for (const card_point of CARD_POINT_LIST) {
    if (card_point.code === card_code) {
      return card_point.name[lang];
    }
  }
  return '-';
};

/**
 * 언어에 따른 은행옵션리스트를 반환한다.
 * @param lang 언어
 * @returns value: 은행코드, text: 언어별 은행이름
 */
export const getBankOptionList = (lang: Language) => {
  return BANK_LIST.map((bank) => ({ value: bank.code_list[0] || '', text: bank.name[lang] }));
};

/**
 * 언어에 따른 카드옵션리스트를 반환한다.
 * @param lang 언어
 * @returns value: 카드코드, text: 언어별 카드이름
 */
export const getCardOptionList = (lang: Language) => {
  return CARD_LIST.map((card) => ({ value: card.code, text: card.name[lang] }));
};

/**
 * 카드 포인트 사용 관련 도움말 텍스트 리스트를 반환한다.
 * @param financial_company_code 파이낸셜 컴터니 코드
 */
export const getCardPointHelpText = (financial_company_code: string) => {
  const code = financial_company_code.split('_')?.[1] ?? '';
  const card_point_help_text = CARD_POINT_HELP_TEXT.find((card) => card.code === code);
  return card_point_help_text ? card_point_help_text.contents : [];
};
